module.exports = __webpack_public_path__ + "img/documents--icon.cb980beb.svg";